import React from 'react';

import styled from 'styled-components';

import { filterAssetsByAssortmentExclusions } from '~/gridv1_1/utils/inGridAssets';
import useAssortmentTestConfigs from '~/shared/utils/useAssortmentTestConfigs';
import { useAsset } from '~/techstyle-shared/react-assets';
import { mobile } from '~/techstyle-shared/react-components';

import useGridInputs from '../../hooks/useGridInputs';

import DiscoveryGuideFilterPill from './DiscoveryGuideFilterPill';

const StyledDiscoverGuideFilterPillList = styled.ul`
  display: flex;
  gap: 8px;
  overflow-x: auto;
  margin: 8px 0;
  list-style: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  ${mobile`
    padding: 0 8px;
  `}
`;

const DiscoveryGuideFilterPills = () => {
  const { gridStyleGuide } = useGridInputs();
  const { excludeFplCodes, excludeTagIds } = useAssortmentTestConfigs();
  const assetContainerName =
    gridStyleGuide?.assetContainers?.mobile ||
    gridStyleGuide?.assetContainers?.desktop;
  const mobileAssetContainer = useAsset(assetContainerName, {
    multi: true,
  });
  const mobileAssets = mobileAssetContainer?.data?.assets || [];
  const filteredAssets = filterAssetsByAssortmentExclusions({
    assets: mobileAssets,
    excludeFplCodes,
    excludeTagIds,
  });

  return (
    <StyledDiscoverGuideFilterPillList>
      {filteredAssets.map((asset) => (
        <li key={asset.id}>
          <DiscoveryGuideFilterPill {...asset} />
        </li>
      ))}
    </StyledDiscoverGuideFilterPillList>
  );
};

export default DiscoveryGuideFilterPills;
